import { RequestState } from '../../types'

export type SubscriptionAccount = {
  id: string
  name: string
  lastActive: Date | undefined
  records: number
  freeRecords: number
  isDemo: boolean
  active: boolean
  requestState: RequestState
  filters: Filter[]
}

export type Subscription = {
  id: string
  name: string
  type: string
  active: boolean
  records: number
  freeRecords: number
  recordAllowance: number
  members: number
  memberAllowance: number
  renewal?: Date
  package: string
  accounts: SubscriptionAccount[]
  requestState: RequestState
  isExpanded: boolean
  error?: string
  invitations: number
}

export type SubscriptionDetails = {
  accounts: SubscriptionAccount[]
}

export type SubscriptionState = {
  requestState: RequestState
  error?: string
  subscriptions: Subscription[]
  loadedPages: number
  totalPages: number
  totalCount: number
  filterPanelOpen: boolean
  searchedForAccount?: SubscriptionAccount
}

export type SubscriptionAccountFilter = {
  id: string
  name: string
  profile: string
  number: number
}

export type Filter = {
  id: string
  key: string
  name: string
  profile: string
  subscription_count: number
  count: number
}

export type FiltersState = {
  filters: Filter[]
  requestState: RequestState
}

export const initialFiltersState: FiltersState = {
  filters: [],
  requestState: RequestState.NotLoaded
}

export const initialSubscriptionsState: SubscriptionState = {
  requestState: RequestState.NotLoaded,
  subscriptions: [],
  loadedPages: 0,
  totalPages: 0,
  totalCount: 0,
  filterPanelOpen: false,
  searchedForAccount: undefined
}
